import { render, staticRenderFns } from "./PriceBlock.vue?vue&type=template&id=1f00da6a&"
import script from "./PriceBlock.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PriceBlock.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f00da6a')) {
      api.createRecord('1f00da6a', component.options)
    } else {
      api.reload('1f00da6a', component.options)
    }
    module.hot.accept("./PriceBlock.vue?vue&type=template&id=1f00da6a&", function () {
      api.rerender('1f00da6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/Analyses/components/PriceBlock/PriceBlock.vue"
export default component.exports